import { Icons } from "assets/icons";
import { useSmartBack } from "hooks/useSmartBack";
import React from "react";

const DetailsTitle = ({ title = "", isBackBtn = true }) => {
  const goBack = useSmartBack();
  const { arrowRight } = Icons;

  return (
    <div className="details_page_title">
      {isBackBtn && (
        <img
          src={arrowRight}
          width={24}
          height={24}
          alt="icon"
          onClick={goBack}
        />
      )}
      <h2>{title}</h2>
    </div>
  );
};

export default DetailsTitle;
